import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import APIRequest from "../../../Services/commonAPIConsumer";
// import { useCookies } from "react-cookie";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import LoginDataService from "../../../Services/LoginService";
import Alert from "../../Controls/Alerts/Alerts";
import { AppContext } from "../../../AppContext";
function MFAAuthentication() {
    const [openLoader, setOpen] = useState(true); // Loader state

    const location = useLocation();
    const mfaResponse = location.state?.response; // Accessing the passed data
    const mfaEnable = location.state?.mfaEnable;
    const ispasswordChanged = location.state?.isPasswordChange;
    const isEnforcePasswordPolicy = location.state?.enforcePasswordPolicy;

    const [alertMsg, setAlertMsg] = useState("");
    const [IsErrorMsg, setIsErrorMsg] = useState(false);
    const [alertType, setAlertType] = useState("");
    const history = useNavigate();
    // const [cookies, setUserNameCookie] = useCookies([""]);
    // const [signCookie, settabCookie] = useCookies([""]);
    // settabCookie("TabSSOSignIn", "SSOSignIn");
    // let UserName = getCookie("UserName");
    // let UserTabSend = getCookie("TabSend");
    // let UserTabSignIn = getCookie("TabSignIn");
    // let UserTabSSOSignIn = getCookie("TabSSOSignIn");
    // let UserTabCreate = getCookie("TabCreate");
    // let UserTabDocumentHistory = getCookie("TabDocumentHistory");
    var rcapURL = AppContext.RCapMFAAndPasswordPolicyUrl;
    // if (window.performance) {
    //     if (performance.navigation.type == 1) {
    //         settabCookie("TabSSOSignIn", "Referesh");
    //     }
    // }
    // function getCookie(name) {
    //     var nameEQ = name + "=";
    //     var ca = document.cookie.split(";");
    //     for (var i = 0; i < ca.length; i++) {
    //         var c = ca[i];
    //         while (c.charAt(0) == " ") c = c.substring(1, c.length);
    //         if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    //     }
    //     return null;
    // }
    useEffect(() => {
        if (mfaResponse) {
            MFAQueryBuilder(mfaResponse, mfaEnable, ispasswordChanged);
            localStorage.setItem("mfaEnable", mfaEnable);
            localStorage.setItem("ispasswordChanged", ispasswordChanged);
        }
    }, []);

    useEffect(() => {
        const receiveMessage = (event) => {
            console.log("Orgin:", event.origin);
            if (event.origin == rcapURL) {
                console.log("window.addEventListener:" + window.addEventListener);
                console.log("Message received:", event.data);
                console.log("Orgin:", event.origin);
                console.log("Message type:", event.type);
                // let data = event.data;

                if (event.type == "message" && event.data != undefined) {
                    console.log("Inside if:", event.data);
                    localStorage.setItem("MFAToken", event.data);
                }
                else if (event.data && JSON.stringify(event.data).indexOf('errorReason') !== -1) {
                    setAlertMsg("You have closed login popup");
                    setAlertType("warning");
                    return;
                }
            }
        };
        // Attach the message event listener
        if (window.addEventListener)
            window.addEventListener("message", receiveMessage, false);
        else window.addEventListener("onmessage", receiveMessage, false);

        return () => {
            // Clean up the event listener when the component unmounts
            if (window.addEventListener)
                window.removeEventListener("message", receiveMessage);
            else window.removeEventListener("onmessage", receiveMessage);
        };
    }, []);


    useEffect(() => {
        if (localStorage.getItem("MFAToken") != null && localStorage.getItem("MFAToken") != undefined) {
            MFALogin(localStorage.getItem("MFAToken"));
            localStorage.removeItem("MFAToken");
        }
    })

    var UserNameSSO = null;
    async function MFALogin(data) {
        try {
            var mFALoginData = {
                email: localStorage.getItem("UserName"),
                password: localStorage.getItem("password"),
                provider_Access_Token: data,
                passwordPolicyChange: localStorage.getItem("ispasswordChanged"),
                MFAEnabled: localStorage.getItem("mfaEnable") == 'true' ? true : false
            };
            var response = await LoginDataService.Login(mFALoginData);
            localStorage.removeItem("ispasswordChanged");
            localStorage.removeItem("mfaEnable");
            if (response && response === "Server maintenance") {
                return;
            }
            else if (response.status === 200) {
                localStorage.removeItem("DocumentID");
                localStorage.removeItem("ManageItem");
                localStorage.setItem("loginTimerCount", 0);
                localStorage.setItem("refresh_timer_count", 0);
                setOpen(false);
                localStorage.setItem("header", "1");
                localStorage.setItem("UserName", response.data.email);
                localStorage.setItem("language", response.data.language);
                localStorage.setItem(
                    "DateControlFormat",
                    response.data.dateControlFormat
                );
                // localStorage.setItem('JWtToken', response.data.jwt);
                localStorage.setItem("SSOType", response.data.ssoType);
                localStorage.setItem("UserRole", response.data.userRole);
                localStorage.setItem("Companyname", response.data.companyname);
                localStorage.setItem("SecureSend", response.data.secureSend);
                // setUserNameCookie("UserName", response.data.email);
                // settabCookie("TabSSOSignIn", "Signed");
                setAlertType("sucess");
                let landingPage = [];

                landingPage = response.data.landingPage.split("_");

                if (landingPage.length > 1) {
                    localStorage.setItem("ManageItem", landingPage[1]);
                    history("/history");
                    return;
                }

                if (landingPage[0] === "Generate") history("/create");
                else history(`/${landingPage[0]}`);

            }
            else if (response != null) {
                if (response.message == "Request failed with status code 400") {
                    history("/", {
                        state: { errorMessage: "Something went wrong, please try again." },
                    });
                }
                if (response.data.errorMessage != null) {
                    history("/", {
                        state: { errorMessage: response.data.errorMessage },
                    });
                }

            } else {
                setOpen(false);
                setAlertMsg("The session has expired. Please log-in again.");
                setAlertType("warning");
                setTimeout(() => {
                    history("/");
                }, 2000);
            }

            // Further processing logic here
        } catch (error) {
            // Handle any errors
            // setOpen(false);
            // setAlertMsg("Failed to load document.");
            // setAlertType("warning");
            return;
        }
    };
    function MFAQueryBuilder(data, isMFA, ispasswordChang) {
        let CallBackUrl = `${process.env.REACT_APP_DomainUrl}`;
        if (ispasswordChang == 1 || isMFA) {
            CallBackUrl = CallBackUrl + "/authenticating";
        }
        let mfaQS = "SourceClientId=" + AppContext.ClientId +
            "&MFAToken=" + data.mfaToken +
            "&CallBackUrl=" + CallBackUrl +
            "&LoginUrl=" + `${process.env.REACT_APP_DomainUrl}` +
            "&MFAEEnabled=" + isMFA +
            "&Lang=" + data.language;
        let encoded = btoa(mfaQS);
        if (ispasswordChang == 1 || ispasswordChang == -1) {
            window.location.href = AppContext.RCapMFAAndPasswordPolicyUrl + "/resetpassword?qs=" + encoded;
        }
        else if (isMFA) {
            window.location.href = AppContext.RCapMFAAndPasswordPolicyUrl + "/email-authentication?qs=" + encoded;
        }
    }
    return (
        <>
            {openLoader ? <LoadingSpinner /> : null}
            <div className="container-login100">
                {/* alerts */}
                <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg}
                    setAlertType={setAlertType}></Alert>
                {/* end */}

                <img
                    className="wave"
                    src="assets/img/wave_yellow.svg"
                    style={{ color: "f2d8da" }}
                    alt="Wave"
                />
                <main className="login_wrapper my2">
                    <div className="container">
                        <div className="text-center mb-2">
                            <img src="assets/img/RDocs.png" className="logo" alt="logo" />
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}

export default MFAAuthentication;